<template>
  <div>
    <el-dialog
      :title="
        currentSystem != 2 && currentSystem != 3 ? '新增商品/券' : '新增商品'
      "
      append-to-body
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="850px"
    >
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane
          label="券列表"
          name="1"
          v-if="currentSystem != 2 && currentSystem != 3"
        >
          <el-form ref="form" :model="voucherPageParm" label-width="80px">
            <el-form-item label="券名称：">
              <el-input
                v-model="voucherPageParm.couponName"
                placeholder="请输入名称查询"
                suffix-icon="el-icon-search"
                style="width: 200px;"
                size="small"
                @change="getVoucherList"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="voucherList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            height="400"
          >
            <el-table-column type="selection" width="55" align="center" />

            <el-table-column prop="couName" label="券名称" align="center" />

            <el-table-column prop="couPrice" label="券金额" align="center" />
            <el-table-column
              prop="couEnableprice"
              label="满可用金额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="couEndtime"
              label="有效期"
              show-overflow-tooltip
              align="center"
            />
            <el-table-column prop="notGetNum" label="未领次数" align="center">
            </el-table-column>
          </el-table>
          <!-- <el-pagination
              style="text-align: center; margin-top: 10px;"
              background
              :page-sizes="[5, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="voucherTotal">
            </el-pagination> -->
          <Pagination
            :childMsg="{ ...voucherPageParm, total: voucherTotal }"
            :pageSizes="pageSizes"
            @callBack="callBack1"
          ></Pagination>
        </el-tab-pane>
        <el-tab-pane label="商品列表" name="2">
          <el-form ref="form" :model="productPageParm" label-width="100px">
            <el-form-item label="商品名称：">
              <el-input
                v-model="productPageParm.productName"
                placeholder="请输入名称查询"
                suffix-icon="el-icon-search"
                style="width: 200px;"
                size="small"
                @change="getProductList"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <el-table
            ref="multipleTable1"
            :data="productList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            height="400"
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column label="商品名称" align="center">
              <template slot-scope="scope">{{ scope.row.pbasSname }}</template>
            </el-table-column>
            <el-table-column prop="pbasPretium" label="商品价格" align="center">
            </el-table-column>
            <el-table-column
              prop="classOne"
              label="商品一级分类"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="商品二级分类">
              <template slot-scope="scope">{{ scope.row.classTwo }}</template>
            </el-table-column>
            <el-table-column prop="notGetNum" label="可用库存" align="center">
            </el-table-column>
          </el-table>
          <Pagination
            :childMsg="{ ...productPageParm, total: productTotal }"
            :pageSizes="pageSizes"
            @callBack="callBack2"
          ></Pagination>
          <!-- <el-pagination
              style="text-align: center; margin-top: 10px;"
              background
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="productTotal"
              @current-change="handleChange"
              > -->
          <!-- </el-pagination> -->
        </el-tab-pane>
        <div style="text-align: right; margin-top: 20px;">
          <el-button type="primary" size="small" @click="submit"
            >确认</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { getCheckSystemApi } from "@/api/index.js";
import { getVoucherList, getProductList } from "@/api/productVoucher/index.js";
export default {
  props: {
    currentSysm: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeName: "2",
      form: {
        name: "",
      },
      dialogVisible: false,
      multipleSelection: [],
      voucherPageParm: {
        currentPage: 1,
        pageSize: 20,
        couponName: "",
      },
      voucherTotal: 0,
      voucherList: [],
      productPageParm: {
        currentPage: 1,
        pageSize: 20,
        productName: "",
      },
      productTotal: 0,
      productList: [],
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      /** 当前系统 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
      currentSystem: 0,
    };
  },
  methods: {
    handleTabClick(e) {
      console.log(this.activeName);
      if (this.activeName == 1) {
        this.$refs.multipleTable1.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      console.log(e);
    },
    handleChange(e) {
      this.productPageParm.currentPage = e;
      this.getProductList();
      console.log(e);
    },
    callBack1(parm) {
      this.voucherPageParm.currentPage = parm.currentPage;
      this.voucherPageParm.pageSize = parm.pageSize;
      this.getVoucherList();
    },
    getVoucherList() {
      getVoucherList(
        this.voucherPageParm,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.voucherList = res.data.rows;
          this.voucherTotal = res.data.total;
        }
        console.log(res);
      });
    },
    callBack2(parm) {
      this.productPageParm.currentPage = parm.currentPage;
      this.productPageParm.pageSize = parm.pageSize;
      this.getProductList();
    },
    getProductList() {
      getProductList(
        this.productPageParm,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.productList = res.data.rows;
          this.productTotal = res.data.total;
        }
        console.log(res);
      });
    },
    show() {
      this.dialogVisible = true;
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    submit() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择商品或者券!");
        return;
      }
      if (this.multipleSelection.length > 1) {
        this.$message.warning("只能选择一种哦!");
        return;
      }
      if (this.multipleSelection.length == 1) {
        let obj = {};
        console.log(this.multipleSelection[0]);
        if (this.activeName == 1) {
          console.log("券");
          obj = {
            title: this.multipleSelection[0].couName,
            price: this.multipleSelection[0].couPrice, //券金额
            couEnableprice: this.multipleSelection[0].couEnableprice, //满可用金额
            // 测试环境券图片链接 http://36.137.14.25:9090/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2023/05/25/b4a1a6f1-241d-476b-beb5-bbdb1180975e.jpg
            // 正式环境券图片链接 http://36.133.227.39:9090/wecom/wpfV9SBgAArfCaq-Y0_Bf5tgO7HxiLQg/2023/05/25/4dc45ddb-6df8-4f15-a832-b785981dd3ab.jpg
            pictureUrl:
              "https://klb-1318632921.cos.ap-guangzhou.myqcloud.com/wecom/wp6BCGBwAAKQ04r-juJDFtyUF_qJ4NwA/2025/03/07/e409b1ab-855d-4bea-8745-84ec1c433608.jpg",
            linkType: "coupon",
            linkUrl: this.multipleSelection[0].linkUrl,
          };
        } else {
          console.log("商品");
          obj = {
            title: this.multipleSelection[0].pbasSname,
            price: this.multipleSelection[0].pbasPretium,
            pictureUrl: this.multipleSelection[0].pbasListpic,
            linkType: "goods",
            linkUrl: this.multipleSelection[0].linkUrl,
          };
        }
        this.$emit("handleSubmit", obj); // 1 券  2 商品
        this.dialogVisible = false;
        this.$refs.multipleTable?  this.$refs.multipleTable.clearSelection():''
        this.$refs.multipleTable1?  this.$refs.multipleTable1.clearSelection():''
      }
    },
    /** 获取当前系统 */
    // getCheckSystem() {
    //   getCheckSystemApi().then((res) => {
    //     console.log("res++++", res.error.code == 200);
    //     if (res && res.error && res.error.code == 200) {
    //       this.currentSysm = res.data || null;
    //     }
    //   });
    // },
  },
  watch: {
    currentSysm(newVal, oldVal) {
      console.log("DFSFSDFSDF", newVal);
      this.currentSystem = newVal;
    },
    immediate: true,
  },
  /** 生命周期 */
  // created() {
  //   this.getCheckSystem();
  // },
};
</script>
<style scoped lang="scss"></style>
